/** Endpoints d'authentification. */

import { apiFetch } from "@/api/client";

export type RegisterPayload = {
  email: string;
  password: string;
  cgu_version: string;
  marketing_emails_opt_in: boolean;
};

export type LoginPayload = {
  email: string;
  password: string;
};

export type GenericMessageResponse = { message: string };

export function register(payload: RegisterPayload) {
  return apiFetch<GenericMessageResponse>("/auth/register", {
    method: "POST",
    body: payload,
  });
}

export function verifyEmail(token: string) {
  return apiFetch<GenericMessageResponse>("/auth/verify-email", {
    method: "POST",
    body: { token },
  });
}

export function resendVerification(email: string) {
  return apiFetch<GenericMessageResponse>("/auth/resend-verification", {
    method: "POST",
    body: { email },
  });
}

export function login(payload: LoginPayload) {
  return apiFetch<GenericMessageResponse>("/auth/login", {
    method: "POST",
    body: payload,
  });
}

export function logout() {
  return apiFetch<GenericMessageResponse>("/auth/logout", { method: "POST" });
}

export function requestPasswordReset(email: string) {
  return apiFetch<GenericMessageResponse>("/auth/password-reset/request", {
    method: "POST",
    body: { email },
  });
}

export function confirmPasswordReset(token: string, newPassword: string) {
  return apiFetch<GenericMessageResponse>("/auth/password-reset/confirm", {
    method: "POST",
    body: { token, new_password: newPassword },
  });
}
